import { render } from "./BadgeProfilesList.vue?vue&type=template&id=2c101d02"
import script from "./BadgeProfilesList.vue?vue&type=script&lang=js"
export * from "./BadgeProfilesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__